import { types as googleServicesMutations } from '~/store/googleServices/mutations';
import SYTE_CONFIG from '~/src/config/syteSearch';
import { addEvents as syteSearchAddEvents } from '~/src/utils/syteSearch';

/**
 * This plugin subscribe to store mutations google services
 *
 * @param {Object} store
 *
 * @return {undefined}
 */
export default function (store) {
    store.subscribe(({ type, payload }) => {
        if (type.replace('googleServices/', '') === googleServicesMutations.SET_GTM) {
            if (payload && !window[SYTE_CONFIG.EVENTS_KEY]) {
                syteSearchAddEvents();
            }
        }
    });
}
